module.exports = "/lucky-balls/img/infobox/info_Box_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_012.png
// module id = 1077
// module chunks = 0